export const SUBSCRIPTION_KEY = ['subscription'] as const;
export const AI_MODELS_KEY = ['ai-models'] as const;
